import { useAppDispatch, useAppSelector } from "../../../hooks/app";
import { getRequestFormData, setRequestFormData } from "../../../store/slices/request-signature.slice";

function StepSelectEndorsement({ endorsements }: { endorsements: any }) {
    const requestFormData = useAppSelector(getRequestFormData)
    const dispatch = useAppDispatch()

    return (
        <div className="signature_step__two">
            <h3 className="heading3 text-center">Select Your Endorsement</h3>
            <div className="input_group">
                <label>Endorsement</label>
                <select className="w-100" value={requestFormData.endorsementId} onChange={(e) => dispatch(setRequestFormData({ endorsementId: e.target.value }))}>
                    <option value="">Select</option>
                    {endorsements?.map((endorsement: any, i: number) => {
                        return <option value={endorsement?._id} key={i}>{endorsement?.name}</option>
                    })}
                </select>
            </div>
        </div>
    );
}

export default StepSelectEndorsement;
